export const account = {

    // --- My account (new settings screen: menu.vue + AccountWelcome.vue) ---
    mc_title: `Mein Konto`,
    mc_subtitle: `Ihre Konto- und Unternehmenseinstellungen`,
    mc_group_account: `Konto`,
    mc_home: `Start`,
    mc_mydata: `Meine Daten`,
    mc_subscription: `Abonnement`,
    mc_billing: `E-Rechnung`,
    mc_whatsapp: `WhatsApp Business`,
    mc_notifications: `Benachrichtigungen`,
    mc_team: `Teamverwaltung`,
    mc_team_badge: `Neu`,
    mc_integrations: `Integrationen`,
    mc_hello: `Hallo`,
    mc_welcome_sub: `Willkommen in Ihrem Konto. Von hier aus verwalten Sie Ihre Unternehmensdaten und die Einstellungen, mit denen das System für Sie arbeitet.`,
    mc_quick: `Schnellzugriff`,
    mc_card_account_title: `Kontoeinstellungen`,
    mc_card_account_desc: `Kontaktdaten, Sprache des Dashboards und Sicherheit.`,
    mc_card_subscription_desc: `Ihr Tarif und die Abrechnung Ihres Abonnements.`,
    mc_card_billing_desc: `Rechnungsaussteller und welcher Aussteller für welche Unterkunft abrechnet.`,
    mc_card_whatsapp_desc: `Die Verbindung, über die das System mit Ihren Gästen spricht.`,
    mc_card_notifications_desc: `Welche Hinweise Sie erhalten und über welche Kanäle.`,
    mc_card_team_desc: `Laden Sie Mitarbeitende ein und verwalten Sie ihre Berechtigungen.`,
    mc_card_integrations_desc: `Verbindungen mit externen Diensten.`,

  p1: `Ihr Konto verwalten`,
  p2: `Kontoeinstellungen`,
  p3: `Sprache`,
  p4: `Anmeldung und Sicherheit`,
  p5: `Mein Abonnement`,
  p6: `Rechnungsdaten`,
  p7: `WhatsApp Business`,
  p8: `Integrationen`,
  p9: `Kontoeinstellungen`,
  p10: `Verwalten Sie die Kontaktdaten, über die Sie alle Mitteilungen von WACheckin erhalten.`,
  p11: `Daten erfolgreich aktualisiert`,
  p12: `Sprache der Plattform`,
  p13: `Wählen Sie Ihre bevorzugte Sprache für Ihr Dashboard. Diese Einstellung beeinflusst nicht die Sprache des Check-ins für Ihre Gäste, denn diese hängt von den Einstellungen ihres Geräts ab.`,
  p14: `Sprache aus der Liste wählen`,
  p15: `Sprache wählen`,
  p16: `Spanisch`,
  p17: `Englisch`,
  p18: `Sprache aktualisieren`,
  p19: `Sprache erfolgreich übernommen`,
  p20: `Hier können Sie Ihr Passwort aktualisieren, um Ihr Konto sicher zu halten.`,
  p21: `Möchten Sie Ihr Passwort ändern?`,
  p22: `Passwort ändern`,
  p23: `Prüfen Sie Ihre E-Mails`,
  p24: `Um mit der Passwortänderung fortzufahren, prüfen Sie Ihren Posteingang und folgen Sie den Schritten`,
  p25: `Weiter`,
  p26: `Hoppla! Es ist ein unerwarteter Fehler aufgetreten`,
  p27: `Daten erfolgreich aktualisiert`,
  p28: `WhatsApp for Business`,
  p29: `Verbinden Sie Ihr WhatsApp Business-Konto mit unserer Plattform und senden Sie Nachrichten direkt von Ihrer personalisierten Nummer an Ihre Gäste.`,
  p30: `Kein Konto verbunden.`,
  p31: `Konto verbinden`,
  p32: `Konto`,
  p33: `Verbunden`,
  p34: `Konto trennen`,
  p35: `Informationen werden geladen...`,
  p36: `WhatsApp for Business trennen`,
  p37: `Möchten Sie WhatsApp for Business wirklich trennen und keine Nachrichten mehr über WhatsApp an Ihre Gäste senden?`,
  p38: `Trennen`,
  p39: `WhatsApp Business-Konto erfolgreich getrennt`,
  p40: `WhatsApp Business-Konto konnte nicht getrennt werden, bitte wenden Sie sich an den Support`,
  p41: `Telefonnummer`,
  p42: `Facebook-Konto`,
  p43: `Unternehmensdaten`,
  p44: `Sie benötigen eine gültige und eindeutige Telefonnummer, um sie mit der WhatsApp Business API zu nutzen.`,
  p45: `Sie erhalten einen Bestätigungscode, um Ihre Nummer auf unserer Plattform zu authentifizieren.`,
  p46: `Ihre geschäftliche Telefonnummer muss eine gültige Nummer sein, die die Kriterien der`,
  p47: `Plattform WhatsApp for Business erfüllt.`,
  p48: `Sie erhalten einen Bestätigungscode, um Ihre Nummer auf unserer Plattform zu authentifizieren.`,
  p49: `Zurück zum Kontostatus`,
  p50: `Weiter`,
  p51: `Sie benötigen ein persönliches Facebook-Konto (verknüpft mit Ihrer geschäftlichen E-Mail-Adresse)`,
  p52: `Wenn Sie ein Facebook Business-Konto erstellt und mit diesem System verbunden haben, müssen Sie es authentifizieren, bevor Sie den Onboarding-Prozess starten, indem Sie auf Mit Facebook anmelden klicken.`,
  p53: `Um Ihr Unternehmenskonto zu authentifizieren, öffnen Sie`,
  p54: `diesen Link`,
  p55: `in einem separaten Tab.`,
  p56: `Sie müssen in Ihrer Authentifizierungs-App einen Code erzeugen und ihn in das Feld "Code eingeben" eintragen.`,
  p57: `Nach der Bestätigung können Sie diesen Tab schließen.`,
  p58: `Zurück zum Kontostatus`,
  p59: `Zurück`,
  p60: `Weiter`,
  p61: `Bereiten Sie Ihre Unternehmensdaten vor`,
  p62: `Sie müssen Ihre Unternehmensdaten zur Hand haben: den offiziellen Namen und die Adresse Ihres Unternehmens sowie das Unternehmenskonto so, wie es angezeigt werden soll.`,
  p63: `Sie benötigen eine gültige Unternehmenswebsite.`,
  p64: `Sie müssen Ihr Konto so bald wie möglich bei Meta verifizieren. Ein verifiziertes Unternehmen kann mit 1000 Nachrichten pro Tag starten. Wenn Sie Ihr Konto nicht verifizieren, deaktiviert Meta es.`,
  p65: `Laut den Richtlinien von Meta kann ein nicht verifiziertes Unternehmenskonto nur mit zwei Nummern verknüpft werden. Verifizieren Sie das Konto, um es mit mehr Nummern zu verknüpfen.`,
  p66: `Zurück zum Kontostatus`,
  p67: `Zurück`,
  p68: `Weiter`,
  p69: `WhatsApp Business-Konto erfolgreich verbunden`,
  
  p70: `Abrechnung`,
  p71: `Status`,
  p72: `Berechneter Betrag`,
  p73: `Bezahlt`,
  p74: `Ausstehend`,
  p75: `Rechnung ansehen`,
  p76: `Keine Abrechnungen gefunden`,
  p77:`Datum`,
  p78: ``,
  p79: ``,
  p80: ``,
};
